"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var immer_1 = require("immer");
var operators_1 = require("../../operators");
var shared_values_model_1 = require("../shared-values.model");
var shared_store_reader_1 = require("../shared-store-reader");
var shared_collection_context_1 = require("./shared-collection-context");
var shared_value_function_context_1 = require("./shared-value-function-context");
var events_context_1 = require("./events-context");
function useSharedValueStoreContext() {
    var store = react_1.useContext(shared_values_model_1.SharedValueContext);
    return react_1.useMemo(function () { return new SharedValueStoreContext(store); }, [store]);
}
exports.useSharedValueStoreContext = useSharedValueStoreContext;
var SharedValueStoreContext = (function () {
    function SharedValueStoreContext(store) {
        this.store = store;
        this.collection = new shared_collection_context_1.SharedCollectionContext(store);
        this.funcs = new shared_value_function_context_1.SharedValueFunctionContext(this);
        this.events = new events_context_1.SharedStoreEventsContext(this);
    }
    SharedValueStoreContext.prototype.batch = function (action) {
        react_dom_1.unstable_batchedUpdates(action);
    };
    SharedValueStoreContext.prototype.get = function (key, valueKeyOrKeys) {
        if (isValueFunction(key)) {
            return this.funcs.get(key);
        }
        else if (isCollectionKey(key)) {
            return this.collection.get(key, valueKeyOrKeys);
        }
        else
            return shared_store_reader_1.getSharedValue(this.store, key);
    };
    SharedValueStoreContext.prototype.getAll = function (key) {
        return this.collection.getAll(key);
    };
    SharedValueStoreContext.prototype.waitFor = function (key, valueKeyOrCriteria, criteria) {
        if (isValueFunction(key)) {
            return this.funcs.waitFor(key, valueKeyOrCriteria);
        }
        else if (isCollectionKey(key)) {
            var valueKey = valueKeyOrCriteria;
            return this.collection.waitFor(key, valueKey, criteria);
        }
        else {
            return this.waitForValue(key, valueKeyOrCriteria);
        }
    };
    SharedValueStoreContext.prototype.waitForNext = function (event, filter) {
        return this.events.waitForNext(event, filter);
    };
    SharedValueStoreContext.prototype.on = function (event, listener) {
        return this.events.on(event, listener);
    };
    SharedValueStoreContext.prototype.stream = function (event) {
        return this.events.stream(event);
    };
    SharedValueStoreContext.prototype.dispatch = function (event, payload) {
        return this.events.dispatch(event, payload);
    };
    SharedValueStoreContext.prototype.changes = function (key, valueKeyOrKeys) {
        if (isValueFunction(key)) {
            return this.funcs.changes(key);
        }
        else if (isCollectionKey(key)) {
            return this.collection.changes(key, valueKeyOrKeys);
        }
        else
            return this.store.onChange(key.id);
    };
    SharedValueStoreContext.prototype.anyChanges = function (key) {
        if (key)
            return this.collection.anyChanges(key);
        else
            return this.store.onAnyChange();
    };
    SharedValueStoreContext.prototype.set = function (key, valueKeyOrValue, value) {
        if (isCollectionKey(key)) {
            var valueKey = valueKeyOrValue;
            return this.collection.set(key, valueKey, value);
        }
        else {
            this.store.setValue(key.id, valueKeyOrValue);
        }
    };
    SharedValueStoreContext.prototype.modify = function (key, valueKeyOrModify, modify) {
        if (isCollectionKey(key)) {
            this.collection.modify(key, valueKeyOrModify, modify);
        }
        else {
            var current = this.get(key);
            var newValue = immer_1.produce(current, valueKeyOrModify);
            this.set(key, newValue);
        }
    };
    SharedValueStoreContext.prototype.modifyAll = function (key, modify) {
        this.collection.modifyAll(key, modify);
    };
    SharedValueStoreContext.prototype.update = function (key, update) {
        return this.collection.update(key, update);
    };
    SharedValueStoreContext.prototype.delete = function (key, valueKey) {
        this.collection.delete(key, valueKey);
    };
    SharedValueStoreContext.prototype.clear = function (key) {
        this.collection.clear(key);
    };
    SharedValueStoreContext.prototype.service = function (factory) {
        var service = factory(this);
        return lodash_mapvalues_1.default(service, wrapServiceFunction);
    };
    SharedValueStoreContext.prototype.waitForValue = function (key, criteria) {
        var value = shared_store_reader_1.getSharedValue(this.store, key);
        if (valueMeetsCriteria(value, criteria))
            return Promise.resolve(value);
        else
            return waitForUpdate(this.store, key.id, criteria);
    };
    return SharedValueStoreContext;
}());
exports.SharedValueStoreContext = SharedValueStoreContext;
function valueMeetsCriteria(value, criteria) {
    if (!criteria)
        return !!value;
    else
        return criteria(value);
}
exports.valueMeetsCriteria = valueMeetsCriteria;
function waitForUpdate(store, key, criteria) {
    return store
        .onChange(key)
        .pipe(operators_1.waitForNext(criteria))
        .toPromise();
}
exports.waitForUpdate = waitForUpdate;
function isCollectionKey(key) {
    return key['collection'] === true;
}
function isValueFunction(key) {
    return typeof key === 'function';
}
function wrapServiceFunction(serviceFunc) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var returnValue;
        react_dom_1.unstable_batchedUpdates(function () {
            returnValue = serviceFunc.apply(void 0, args);
        });
        return returnValue;
    };
}
//# sourceMappingURL=data:application/json;base64,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